import React from 'react';

const LogisticsActionLinkDeliveryDetails = ({ infoTexts }: any) => {
  const {
    bookingNumberText,
    toName,
    contactInfo,
    trackingNumberText,
    withText,
    statusText
  } = infoTexts;
  return (
    <>
      <h3 className="bold">{bookingNumberText}</h3>
      <p className="collapse secondary">To</p>
      <p className="collapse bold">{toName}</p>
      <p className="collapse">{contactInfo}</p>
      <p>{withText}</p>
      <p>{trackingNumberText}</p>
      <p className="bold">{statusText}</p>
    </>
  );
};

export default LogisticsActionLinkDeliveryDetails;
